import {
  _sharedActionsSystem,
  _sharedActionsConstantsSystem
} from "@/shared/store/system/actions";

export const systemActionsConstants = {
  ..._sharedActionsConstantsSystem,
  SET_SCREEN_TYPE: "system/ACTION_SET_SCREEN_TYPE",
};
export const systemActions = {
  ..._sharedActionsSystem,
  setScreenType: (screenType) => ({
    type: systemActionsConstants.SET_SCREEN_TYPE,
    data: screenType,
  }),
};
